import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeletePessoaInfo() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deletePessoaInfo = useCallback(
        (pessoaId: string, id: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Pessoa/${pessoaId}/info/${id}`,
                method: 'DELETE',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deletePessoaInfo,
    };
}